import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithReauth } from '@/services';
import { API_BUSINESS_URL } from '@/utils';
import type { SelectInputOption } from '@/components/inputs/SelectInput';

const logisticOperatorGroupsService = createApi({
  reducerPath: 'logisticOperatorGroupsService',
  baseQuery: createBaseQueryWithReauth(
    `${API_BUSINESS_URL}/logistic-operator-group`
  ),
  tagTypes: ['LogisticOperatorGroups'],
  endpoints: (builder) => ({
    getLogisticOperatorGroups: builder.query<
      SelectInputOption[],
      { limit?: number; offset?: number; name?: string } | void
    >({
      query: (args) => ({
        url: '',
        params: {
          limit: args?.limit ?? 50,
          offset: args?.offset ?? 0,
          ...(args?.name &&
            args.name.trim() !== '' && { name: args.name.trim() }),
        },
      }),
      transformResponse: (response: any): SelectInputOption[] => {
        const data = response?.data ?? response ?? {};
        const rows = Array.isArray(data.items)
          ? data.items
          : Array.isArray(data.rows)
            ? data.rows
            : Array.isArray(data)
              ? data
              : [];
        return rows
          .map((g: any) => ({
            value: String(g.id ?? ''),
            label: String(g.name ?? ''),
          }))
          .filter((o: SelectInputOption) => o.value && o.label);
      },
      providesTags: ['LogisticOperatorGroups'],
    }),
  }),
});

export default logisticOperatorGroupsService;
export const { useGetLogisticOperatorGroupsQuery } =
  logisticOperatorGroupsService;
